import { css } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';

export default class EprelQrStyle {
	/**
	 * Returns styles.
	 *
	 * @param options Options.
	 * @param options.theme ...
	 * @returns Styles.
	 */
	public static getStyle(options: { theme: ITheme }): string {
		return css`
			.container {
				display: flex;
				flex-direction: column;
				align-items: center;
				position: relative;
			}
			kompis-text {
				margin-bottom: ${options.theme.spacing.space150 / 16}rem;
				margin-top: ${options.theme.spacing.space100 / 16}rem;
			}
			kompis-qr-code {
				display: contents;
				width: 80%;
			}
		`;
	}
}
